const affiliateSearchOnboard = [
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_BuscaDeRede_1.png",
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_BuscaDeRede_2.png",
  "https://stgkippapps.blob.core.windows.net/img/Tutorial_BuscaDeRede_3.png"
];

export default affiliateSearchOnboard;
